<template>
  <div>
    <div class="row gy-5 g-xl-8">
      <div class="mb-0" :class="{ 'mt-0': !dialog }">
        <div class="border-0 pt-0">
          <div class="col">
            <div class="row">
              <div class="col-lg-12 fv-row">
                <div class="fv-row mb-0">
                  <div class="input-group">
                    <span class="input-group-text">
                      <i class="bi bi-search"></i>
                    </span>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      placeholder="Buscar por caminho do arquivo..."
                      v-model="filtroTexto"
                      @keyup="keyupFiltroTexto"
                    />
                    <button
                      type="button"
                      class="btn btn-sm btn-light-primary"
                      @click="carregarItens()"
                      title="Atualizar"
                    >
                      <i class="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="py-3">
          <div class="table-responsive">
            <table
              class="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4"
            >
              <thead>
                <tr class="fw-bolder text-dark">
                  <th style="width: 150px" class="text-center">
                    Bloqueios ({{ itensTotal }})
                  </th>
                  <th style="width: 200px" class="text-start">Usuário</th>
                  <th class="text-start">Arquivo</th>
                  <th style="width: 100px" class="text-center">Ações</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="item in itens" :key="item._id" :item="item">
                  <td class="text-start">
                    <span
                      class="text-center text-dark fw-bold d-block fs-7 mt-1"
                    >
                      {{ $funcoes.formatarDataHora(item.dataCriacao) }}
                    </span>                    
                  </td>
                  <td class="text-start">
                    <div
                      class="d-flex align-items-center"
                      v-if="item.usuario && usuarios[item.usuario]"
                    >
                      <div class="symbol symbol-45px me-5">
                        <img
                          :src="
                            $funcoes.usuarioFoto(
                              item.usuario,
                              usuarios[item.usuario].foto ? true : false
                            )
                          "
                          alt=""
                        />
                      </div>
                      <div class="d-flex justify-content-start flex-column">
                        <span class="text-dark fw-bolder fs-6">
                          {{ usuarios[item.usuario].nome }}
                        </span>
                        <span class="text-muted fw-bold d-block fs-7">{{
                          usuarios[item.usuario].nomeUsuario
                        }}</span>
                      </div>
                    </div>
                    <div v-else-if="item.owner">
                      <span class="text-muted fw-bold d-block fs-7">{{
                        item.owner
                      }}</span>
                    </div>
                    <div v-else>
                      <span class="text-muted fw-bold d-block fs-7">-</span>
                    </div>
                  </td>
                  <td class="">
                    <div>
                      <span class="text-dark fw-bold d-block fs-7">{{
                        item.fullPath || item.path
                      }}</span>
                    </div>
                  </td>
                  <td class="text-center">
                    <button
                      type="button"
                      class="btn btn-sm btn-icon btn-light-danger"
                      @click="removerLock(item)"
                      title="Remover bloqueio"
                    >
                      <i class="bi bi-unlock"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="itens.length === 0">
                  <td colspan="4" class="text-center text-muted py-5">
                    Nenhum arquivo bloqueado
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <Paginacao
            ref="paginacao"
            :center="true"
            :total="itensTotal"
            :limit="10"
            @change-pagina="carregarItens()"
          />
        </div>
      </div>
    </div>
    <DialogMensagem
      ref="dialogRemover"
      titulo="Remover bloqueio"
      :mensagem="'Confirme caso deseje remover o bloqueio do arquivo \'' + (itemRemover ? (itemRemover.fullPath || itemRemover.path) : '') + '\''" 
      :tipo="'simnao'"
      classBody="mx-5 mx-xl-15 my-1 text-center"
      @confirmar="confirmarRemover"
      @cancelar="cancelarRemover"
    />
  </div>
</template>

<script>
import { api } from "@/plugins/api.js";
import { useAuthStore } from "@/stores/auth.js";
import Paginacao from "../components/ComponentPaginacao.vue";
import DialogMensagem from "../components/ComponentDialogMensagem.vue";

export default {
  components: { Paginacao, DialogMensagem },
  props: {
    dialog: { type: Boolean, default: false },
    instancia: { type: String, default: "" }
  },
  data() {
    return {
      timerFiltroTexto: null,
      itensTotal: 0,
      filtroTexto: "",
      itens: [],
      usuarios: {},
      itemRemover: null
    };
  },

  setup() {
    const storeAuth = useAuthStore();
    return { storeAuth };
  },

  mounted() {},

  watch: {},

  methods: {
    async carregarItens() {
      let filtros = "";

      filtros += "?_limit=" + 10;
      filtros += "&_page=" + this.$refs.paginacao.pagina;

      if (this.filtroTexto !== "") {
        filtros += "&fullPath=" + encodeURIComponent(this.filtroTexto);
      }

      //* Define a api da nuvem a ser chamada
      let apiNuvem =
        this.storeAuth?.nuvem[this.$props.instancia] !== null
          ? this.storeAuth.apiNuvem(this.$props.instancia)
          : this.storeAuth.apiNuvem();

      //* Carrega os dados dos usuarios possiveis
      this.carregarUsuarios();

      //* Carrega os locks
      const response = await api.get(apiNuvem + "/lock" + filtros);

      api.valid(response.data, this.$router);

      this.itens = response.data.locks || [];
      this.itensTotal = response.data.total || 0;
    },
    async carregarUsuarios() {
      const token =
        this.$props.instancia !== "" &&
        this.storeAuth.token[this.$props.instancia] !== ""
          ? this.storeAuth.token[this.$props.instancia]
          : null;

      this.usuarios = await api.getItensObjectId(
        window._env_.VUE_APP_URL_API + "/admin/usuario",
        token
      );
    },
    keyupFiltroTexto() {
      clearTimeout(this.timerFiltroTexto);

      const obj = this;

      this.timerFiltroTexto = setTimeout(function () {
        obj.$refs.paginacao.pagina = 1;
        obj.carregarItens();
      }, 300);
    },
    removerLock(item) {
      this.itemRemover = item;
      
      if (this.dialog) {
        this.$emit("dialog-on");
      }
      
      this.$refs.dialogRemover.abrir();
    },
    async confirmarRemover() {
      if (!this.itemRemover) return;

      //* Define a api da nuvem a ser chamada
      let apiNuvem =
        this.storeAuth?.nuvem[this.$props.instancia] !== null
          ? this.storeAuth.apiNuvem(this.$props.instancia)
          : this.storeAuth.apiNuvem();

      const response = await api.delete(
        apiNuvem + "/lock/" + this.itemRemover.token
      );

      if (response.data.erro === false) {
        this.carregarItens();
      }

      this.itemRemover = null;
      this.$refs.dialogRemover.fechar();
      
      if (this.dialog) {
        this.$emit("dialog-off");
      }
    },
    cancelarRemover() {
      this.itemRemover = null;
      this.$refs.dialogRemover.fechar();
      
      if (this.dialog) {
        this.$emit("dialog-off");
      }
    },
    limparFiltros() {
      this.filtroTexto = "";
    }
  }
};
</script>

<style></style>
